import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'

import {
  Label,
  Popup,
  Form
} from 'semantic-ui-react'

import { AUTH_API_URL } from '_constants'
import { isNilOrEmpty, notNilOrEmpty } from '_utils'

import { get } from '_utils/xhr'

import AutoCompleteUrl from '_views/autocomplete/url'
import AutoComplete from '_views/autocomplete/'

const ErrorMsg = ({
  error
}) => isNilOrEmpty(error)
  ? null
  : <Label basic color='red' pointing='below'>{error}</Label>

ErrorMsg.propTypes = {
  error: PropTypes.string
}

export default ({
  icon,
  placeholder,
  idName,
  baseSearchUrl,
  formatSelection,
  formatSuggestion
}) => {
  const getAcUrl = term => `${AUTH_API_URL}/${baseSearchUrl}/?query=${term}`
  const PluralSearch = ({
    zIndex,
    autocomplete,
    onTermChange,
    onSelectionChange,
    onClearSuggestions
  }) => <AutoComplete
    zIndex={zIndex}
    icon={icon}
    minWidth={300}
    placeholder={placeholder}

    uniqField='_id'
    isLoading={autocomplete.isLoading}
    total={autocomplete.total}
    pageNum={autocomplete.pageNum}
    selections = { autocomplete.selections }
    suggestions = { autocomplete.suggestions }

    onTermChange={onTermChange}
    onSelectionChange={onSelectionChange}
    onClearSuggestions={onClearSuggestions}

    formatSelection={ formatSelection }
    formatSuggestion={ formatSuggestion }
  />

  PluralSearch.propTypes = {
    zIndex: PropTypes.number,
    onTermChange: PropTypes.func.isRequired,
    onSelectionChange: PropTypes.func.isRequired,
    onClearSuggestions: PropTypes.func.isRequired,
    autocomplete: PropTypes.shape({
      selections: PropTypes.array.isRequired,
      suggestions: PropTypes.array.isRequired,
      isLoading: PropTypes.bool.isRequired,
      total: PropTypes.number.isRequired,
      pageNum: PropTypes.number.isRequired
    })
  }

  class SingularSearch extends React.PureComponent {
    state = {
      selections: []
    }

    componentDidMount () {
      this.getLicense()
    }

    getLicense = _ => {
      if (isNilOrEmpty(this.props[idName])) {
        return
      }
      const url = `/${baseSearchUrl}/${this.props[idName]}`
      return get(url, {})
        .then(body => this.setState({selections: [body]}))
        .catch(console.error)
    }

    onAcChange = (_selections, sel) => sel && sel._id
      ? this.setState({selections: [sel]}, () => this.props.onChange(null, sel)) // FIXME: we need to make onchange handlers uniform
      : this.setState({selections: []}, () => this.props.onChange(null, null))

    render = () => (
      <Form.Field
        error={notNilOrEmpty(this.props.error)}
        disabled={this.props.disabled}
        width={this.props.width || null}
      >
        <Popup
          trigger={<label>{this.props.labelTxt}</label>}
          content={this.props.popupTxt}
        />
        <ErrorMsg error={this.props.error} />
        <AutoCompleteUrl
          zIndex={this.props.zIndex}
          minWidth={300}
          icon={icon}
          placeholder={this.props.placeholder || placeholder || 'Type to search ...'}
          selections={this.state.selections}
          onSelectionChange={this.onAcChange}
          getUrl={getAcUrl}
          uniqField='_id'
          mapHttpBodyToSuggestions={R.prop('results')}
          formatSelection={ formatSelection }
          formatSuggestion={ formatSuggestion }
        />
      </Form.Field>
    )
  }

  SingularSearch.propTypes = {
    zIndex: PropTypes.number,
    error: PropTypes.string,
    disabled: PropTypes.bool,
    [idName]: function (props, propName, componentName) {
      if (props[propName] && !/^[a-f\d]{24}$/.test(props[propName])) {
        return new Error(
          'Invalid prop `' + propName + '` supplied to' +
          ' `' + componentName + '`. Validation failed.'
        )
      }
    },
    width: PropTypes.number,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    popupTxt: PropTypes.string.isRequired,
    labelTxt: PropTypes.string.isRequired

  }
  return {
    PluralSearch,
    SingularSearch
  }
}



// WEBPACK FOOTER //
// ./webAdmin/forms/searchHOC.js